import { makeStyles } from '@material-ui/styles';
import cn from 'clsx';
import Text from '../Text';
import { Theme } from '../../theme/types';

type TagProps = {
    tagText: string;
    className?: string;
};

const Tag = ({ tagText, className }: TagProps) => {
    const classes = useStyles();
    return (
        <div className={cn(classes.tagContainer, className)}>
            <Text variant="t81" className={classes.tagText}>
                {tagText}
            </Text>
        </div>
    );
};

const useStyles = makeStyles<Theme>(
    theme => ({
        tagContainer: {
            padding: '0px 4px',
            background: theme.palette.accent['600'],
            borderRadius: 4,
            display: 'inline-flex',
        },
        tagText: {
            color: theme.palette.greys['100'],
            display: 'block',
            lineHeight: 1.6,
        },
    }),
    {
        classNamePrefix: 'Tag',
    }
);

export default Tag;
